import { motion } from "framer-motion";
import { Building2, Radiation, Atom } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { HOSPITALS } from "../content/siteContent";
import { locHospitalNote } from "../content/i18n_extra";

export function Hospitals() {
  const { t, lang } = useLang();

  return (
    <section id="hastaneler" className="bg-ice py-28 sm:py-36" data-testid="hospitals-section">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl"
        >
          <div className="text-xs font-heading font-bold tracking-[0.18em] sm:tracking-[0.3em] uppercase text-brand mb-4">{t("sec_hospitals_kicker")}</div>
          <h2 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight text-ink text-balance">{t("sec_hospitals_title")}</h2>
        </motion.div>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-5">
          {HOSPITALS.map((h, i) => (
            <motion.div
              key={h.name}
              data-testid={`hospital-card-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.08 }}
              className="rounded-3xl bg-white border border-black/5 p-7 shadow-sm hover:-translate-y-1 hover:shadow-xl transition-[transform,box-shadow] duration-300"
            >
              <div className="flex items-start justify-between gap-3">
                <div className="w-11 h-11 rounded-2xl bg-brand/10 flex items-center justify-center text-brand">
                  {h.type === "heavy" ? <Atom size={20} /> : h.type === "proton" ? <Radiation size={20} /> : <Building2 size={20} />}
                </div>
                <span className="text-[10px] font-bold tracking-widest uppercase px-2.5 py-1 rounded-full bg-mist text-sub">
                  {h.type === "heavy" ? "Heavy Ion" : h.type === "proton" ? "Proton" : "Clinic"}
                </span>
              </div>
              <h3 className="mt-5 font-heading text-lg font-bold text-ink leading-snug">{h.name}</h3>
              <p className="mt-1.5 text-xs text-sub">{locHospitalNote(i, lang, h.note)}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
